import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const QuestionMark: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 16 17"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5ZM7.088 10.392V10.596H8.708V10.464C8.708 10.272 8.732 10.1 8.78 9.948C8.836 9.788 8.932 9.624 9.068 9.456C9.212 9.28 9.416 9.072 9.68 8.832C10.016 8.528 10.276 8.212 10.46 7.884C10.652 7.556 10.748 7.172 10.748 6.732C10.748 6.06 10.512 5.52 10.04 5.112C9.568 4.704 8.892 4.5 8.012 4.5C7.076 4.5 6.364 4.732 5.876 5.196C5.388 5.652 5.096 6.24 5 6.96L6.644 7.14C6.732 6.74 6.872 6.448 7.064 6.264C7.264 6.08 7.552 5.988 7.928 5.988C8.256 5.988 8.504 6.076 8.672 6.252C8.848 6.42 8.936 6.668 8.936 6.996C8.936 7.252 8.872 7.472 8.744 7.656C8.624 7.832 8.456 8.028 8.24 8.244C7.928 8.548 7.688 8.812 7.52 9.036C7.352 9.252 7.236 9.464 7.172 9.672C7.116 9.872 7.088 10.112 7.088 10.392ZM8.756 13.212V11.424H7.028V13.212H8.756Z"
      />
    </svg>
  );
};

export default QuestionMark;
